/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal, Checkbox, Popup, List, Dropdown, Icon, Form
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import FileSaver from 'file-saver';
import Update from 'immutability-helper';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import userPic from '../../images/common/profile_icon_big.png';
import AssigningUserModal from './AssigningUserModal';
import ApplyingPolicyModal from './ApplyingPolicyModal';
import AssigningGroupModal from './AssigningGroupModal';
import ChangeOwnerModal from './ChangeOwnerModal';
import DeleteProjectModal from './DeleteProjectModal';
import WithRouter from '../Extensions/WithRouter';
import AddUserDefinedModal from './AddUserDefinedModal';
import ResultRenderer from '../ResultRenderer/ResultRenderer';

class EditProjectModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.nameInput = React.createRef();
    this.projectNM = React.createRef();
    this.projectMB = React.createRef();
    this.versionInput = React.createRef();
    this.projectVersionNM = React.createRef();
    this.appliedPL = React.createRef();
    this.appliedUD = React.createRef();

    this.state = {
      isOpenMEP: props.isOpenMEP,
      isOpenMAU: false,
      isOpenMCO: false,
      isOpenMDP: false,
      isOpenMAC: false,
      isOpenMAG: false,
      isOpenVM: false,
      isOpenMUD: false,
      isLoading: false,
      versionIndex: '',
      selectedVersionName: '',
      viewPoint: '1',
      id: '',
      status: null,
      owners: '',
      info: '',
      versionList: [],
      uploadedFileList: [],
      selectedGroupIds: [],
      projectName: '',
      projectNameError: '',
      description: '',
      projectVersion: '',
      projectVersionError: '',
      appliedPolicerError: '',
      selectedMemberList: [
        {
          id: props.state.user.id,
          profile: props.state.user.name,
          email: props.state.user.email,
          type: 'user',
        },
      ],
      selectedPolicyList: [],
      checkValue: [],
      itemsChecked: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isLoader: false,
      isPolicyChecked: false,
      policyValues: [],
      popupStatus: {
        fileInfo: '',
      },
      selectedUserDefinedList: [],
      isUserdefinedCheckedAll: false,
      userDefinedValues: [],
      copied: false,
      tooltipWithKeyName: '',
      tooltipWithDetailValue: '',
      isDownloadingReport: false,
      isOpenReportModal: false,
      declaredLicense: '',
      revertDeclaredLicense: '',
      resultList: [],
      isActiveResult: false,
      selectedResultData: '',
      isOpenAttentionModal: false,
      excludePolicyIds: [],
    };
    this.handleViewPostion = this.handleViewPostion.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handleAddPolicy = this.handleAddPolicy.bind(this);
    this.handleChangeOwner = this.handleChangeOwner.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleVMOpen = this.handleVMOpen.bind(this);
    this.handleVMClose = this.handleVMClose.bind(this);
    this.handleMAUClose = this.handleMAUClose.bind(this);
    this.handleMCOClose = this.handleMCOClose.bind(this);
    this.handleMDPClose = this.handleMDPClose.bind(this);
    this.handleMAGClose = this.handleMAGClose.bind(this);
    this.handleMACClose = this.handleMACClose.bind(this);
    this.handleProjectNameChange = this.handleProjectNameChange.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleAddNewVersion = this.handleAddNewVersion.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveProject = this.handleRemoveProject.bind(this);
    this.handleRemovePolicy = this.handleRemovePolicy.bind(this);
    this.handleDeleteCallback = this.handleDeleteCallback.bind(this);
    this.handleProjectVersionChange = this.handleProjectVersionChange.bind(this);
    this.handleMemberList = this.handleMemberList.bind(this);
    this.handlePolicyList = this.handlePolicyList.bind(this);
    this.handleOwnerCallback = this.handleOwnerCallback.bind(this);
    this.handleMemberCheckChange = this.handleMemberCheckChange.bind(this);
    this.handleMemberCheckAll = this.handleMemberCheckAll.bind(this);
    this.handlePolicyCheckChange = this.handlePolicyCheckChange.bind(this);
    this.handlePolicyCheckAll = this.handlePolicyCheckAll.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleOpenFileInfoPopup = this.handleOpenFileInfoPopup.bind(this);
    this.handleCloseFileInfoPopup = this.handleCloseFileInfoPopup.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.addNewVersion = this.addNewVersion.bind(this);
    this.closeEditProjectModal = this.closeEditProjectModal.bind(this);
    this.getByteLength = this.getByteLength.bind(this);
    this.handleUserDefinedCheckAllChange = this.handleUserDefinedCheckAllChange.bind(this);
    this.handleUserDefinedCheckChange = this.handleUserDefinedCheckChange.bind(this);
    this.handleAddUserDefined = this.handleAddUserDefined.bind(this);
    this.handleRemoveUserDefined = this.handleRemoveUserDefined.bind(this);
    this.handleAddUserDefinedCallback = this.handleAddUserDefinedCallback.bind(this);
    this.handleMUDClose = this.handleMUDClose.bind(this);
    this.openTooltipWithKeyName = this.openTooltipWithKeyName.bind(this);
    this.closeTooltipWithKeyName = this.closeTooltipWithKeyName.bind(this);
    this.openTooltipWithDetailValue = this.openTooltipWithDetailValue.bind(this);
    this.closeTooltipWithDetailValue = this.closeTooltipWithDetailValue.bind(this);
    this.closeReportModal = this.closeReportModal.bind(this);
    this.exportProjectToPDF = this.exportProjectToPDF.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleChangeLicnese = this.handleChangeLicnese.bind(this);
    this.handleFocusOnLicense = this.handleFocusOnLicense.bind(this);
    this.handleBlurOnLicense = this.handleBlurOnLicense.bind(this);
    this.handleLicenseResultSelect = this.handleLicenseResultSelect.bind(this);
    this.closeAttentionModal = this.closeAttentionModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMEP, state, projectId } = this.props;

    if (prevProps.isOpenMEP !== isOpenMEP) {
      this.setState({
        isOpenMEP,
        versionList: [],
        projectName: '',
        projectNameError: '',
        description: '',
        projectVersion: '',
        projectVersionError: '',
        selectedMemberList: [
          {
            id: state.user.id,
            profile: state.user.name,
            email: state.user.email,
            type: 'user',
          },
        ],
        selectedPolicyList: [],
        selectedGroupIds: [],
        isPolicyChecked: false,
        policyValues: [],
        appliedPolicerError: '',
        modalAlertMsg: '',
        modalAlertTitle: '',
        viewPoint: '1',
        status: null,
        checkValue: [],
        itemsChecked: false,
        popupStatus: {
          fileInfo: '',
        },
        isLoader: false,
        selectedUserDefinedList: [],
        isUserdefinedCheckedAll: false,
        userDefinedValues: [],
        copied: false,
        tooltipWithKeyName: '',
        tooltipWithDetailValue: '',
        isDownloadingReport: false,
        isOpenReportModal: false,
        declaredLicense: '',
        revertDeclaredLicense: '',
        resultList: [],
        isActiveResult: false,
        selectedResultData: '',
        isOpenAttentionModal: false,
        excludePolicyIds: [],
      }, () => {
        if (isOpenMEP) {
          this.getProjectDetail(projectId);
        }
      });
    }

  }

  componentWillUnmount() {}

  handleSave(event) {
    event.preventDefault();

    const {
      projectName,
      status,
      description,
      declaredLicense,
      id,
      versionList,
      owners,
      selectedMemberList,
      selectedPolicyList,
      selectedUserDefinedList
    } = this.state;

    const { translate } = this.props;
    const newMemberArr = [];
    const newVersionArr = [];
    const policyIds = [];
    const groupIds = [];
    const userDefinedIds = [];

    let i = 0;

    selectedMemberList.map((item) => {
      if (item.type === 'user') {
        return newMemberArr.push(item.email);
      }
      if (item.type === 'group') {
        return groupIds.push(item.id);
      }
      return null;
    });

    for (i; i < selectedPolicyList.length; i++) {
      if (selectedPolicyList[i].applied !== 'company') {
        policyIds.push(selectedPolicyList[i].id);
      }
    }

    selectedUserDefinedList.forEach((item) => {
      if (item.applied !== 'company') {
        userDefinedIds.push(item.user_defined_id);
      }
    });

    versionList.map((item) => {
      if (item.id === 0 && item.status !== 'add') {
        return false;
      }
      return newVersionArr.push({
        id: item.id,
        name: item.name,
        status: item.status,
      });
    });

    const formData = {
      name: projectName,
      status,
      description,
      versions: newVersionArr,
      owners: owners.email,
      members: newMemberArr,
      policy_ids: policyIds,
      group_ids: groupIds,
      user_defined_ids: userDefinedIds,
      declared_license: declaredLicense.trim(),
    };

    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .updateProject(id, formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('modal.message.update_project'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-356') {
          this.setState({
            projectNameError: translate('modal.error.duplicate_project'),
            modalAlert: false,
          });
          this.nameInput.current.focus();
          this.projectNM.current.scrollIntoView();
        } if (o.error === '422-357') {
          this.setState({
            projectVersionError: translate('modal.error.duplicate_project_version'),
            modalAlert: false,
          });
          this.versionInput.current.focus();
          this.projectVersionNM.current.scrollIntoView();
        } else if (o.error === '422-358') {
          this.setState({
            projectVersionError: translate('modal.error.error_422_358'),
            modalAlert: false,
          });
          this.versionInput.current.focus();
          this.projectVersionNM.current.scrollIntoView();
        } else if (o.error === '422-354') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_354'),
          });
        } else if (o.error === '422-355') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_355'),
          });
        } else if (o.error === '422-359') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_359'),
          });
        } else {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description || translate('modal.error.unknow_error'),
          });
        }

        this.setState({
          isLoading: false,
          isLoader: false,
        });
      });
  }

  handleCloseAlert() {
    const { modalAlertTitle } = this.state;
    const { closeModal, completeCallback } = this.props;
    if (!modalAlertTitle) {
      return this.setState({ modalAlert: false });
    }
    this.setState({
      modalAlert: false,
      isOpenMEP: false,
    });
    completeCallback(200);
    closeModal();
  }

  handleVersionChange = (e, index) => {
    const { versionList } = this.state;

    const versions = [...versionList];
    const item = { ...versions[index] };

    if (item.status === 'add') {
      item.name = e.target.value;
    } else {
      item.name = e.target.value;
      item.status = 'change';
    }

    versions[index] = item;

    this.setState({
      versionList: versions,
    });
  };

  handleOnScroll = () => {
    const { uploadedFileList } = this.state;
    if (uploadedFileList.length === 0) {
      return;
    }
    const status = {
      filesInfo: '',
    };
    this.setState({
      popupStatus: status,
      uploadedFileList: [],
    });
  };

  handleStatusChange(e, { value }) {
    const { status } = this.state;
    if (value === status) {
      return;
    }
    this.setState({
      status: value,
    });
  }

  handleAddNewVersion(event) {
    if (event.key === 'Enter') {
      this.addNewVersion();
    }
  }

  handleAddGroup() {
    this.setState({
      isOpenMAG: true,
    });
  }

  handleAddPolicy() {
    const { selectedPolicyList } = this.state;

    const excludeIds = selectedPolicyList.map((item) => {
      return item.id;
    });

    this.setState({
      isOpenMAC: true,
      excludePolicyIds: excludeIds,
    });
  }

  handleViewPostion(e) {
    if (e.currentTarget.dataset.id === '1') {
      this.projectNM.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '2') {
      this.projectMB.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '3') {
      this.appliedPL.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '4') {
      this.appliedUD.current.scrollIntoView();
    }

    this.setState({
      viewPoint: e.currentTarget.dataset.id,
    });
  }

  handleProjectNameChange(e) {
    this.setState({
      projectName: e.target.value,
      projectNameError: '',
    });
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
      //descriptionError: '',
    });
  }

  handleProjectVersionChange(e) {
    const { translate } = this.props;
    if (this.getByteLength(e.target.value) > 20) {
      this.setState({
        projectVersionError: translate('modal.error.version_limited_char'),
      });
      return false;
    }
    this.setState({
      projectVersion: e.target.value,
      projectVersionError: '',
    });
  }

  handleMemberCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleMemberCheckAll() {
    const { itemsChecked, selectedMemberList, owners } = this.state;
    const newState = [];
    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const newData = selectedMemberList.filter((item) => {
        return item.email !== owners.email;
      });
      const num = newData.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(`${newData[i].type}_${newData[i].id}`);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);

      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handlePolicyCheckChange(e, { value }) {
    const { policyValues } = this.state;
    let newState;
    if (policyValues.indexOf(value) > -1) {
      newState = policyValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...policyValues, value];
    }
    this.setState({
      policyValues: newState,
    });
  }

  handlePolicyCheckAll() {
    const { isPolicyChecked, selectedPolicyList } = this.state;
    const newState = [];

    if (isPolicyChecked) {
      this.setState({
        isPolicyChecked: false,
        policyValues: [],
      });
    } else {
      const newData = selectedPolicyList.filter((item) => {
        return item.applied !== 'company';
      });
      const num = newData.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(newData[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        isPolicyChecked: true,
        policyValues: unique,
      });
    }
  }

  handlePolicyList(newArr) {
    const { selectedPolicyList } = this.state;

    this.setState({
      selectedPolicyList: Update(selectedPolicyList, {
        $push: newArr,
      }),
    });
  }

  handleUserDefinedCheckAllChange() {
    this.setState((prevState) => {
      const { isUserdefinedCheckedAll, selectedUserDefinedList } = prevState;
      if (isUserdefinedCheckedAll) {
        return {
          isUserdefinedCheckedAll: false,
          userDefinedValues: [],
        };
      }
      const filteredList = selectedUserDefinedList.filter((item) => { return item.applied !== 'company'; });
      const newState = filteredList.map((item) => { return item.user_defined_id; });
      const unique = [...new Set(newState)];
      return {
        isUserdefinedCheckedAll: true,
        userDefinedValues: unique,
      };
    });
  }

  handleUserDefinedCheckChange(e, { value }) {
    this.setState((prevState) => {
      const { userDefinedValues, selectedUserDefinedList } = prevState;

      const isCompany = selectedUserDefinedList.some((item) => { return item.user_defined_id === value && item.applied === 'company'; });

      if (isCompany) return {};

      const newValue = userDefinedValues.includes(value)
        ? userDefinedValues.filter((el) => { return el !== value; })
        : [...userDefinedValues, value];
      const allSelected = newValue.length > 0 && selectedUserDefinedList.every((item) => { return item.applied !== 'company' && newValue.includes(item.user_defined_id); });

      return {
        userDefinedValues: newValue,
        isUserdefinedCheckedAll: allSelected,
      };
    });
  }

  handleMemberList(newArr) {
    const { selectedMemberList } = this.state;
    const newIds = [];
    let i = 0;

    this.setState({
      selectedMemberList: Update(selectedMemberList, {
        $push: newArr,
      }),
    }, () => {
      const groupList = selectedMemberList.filter((item) => {
        return item.type === 'group';
      });
      if (groupList.length !== 0) {
        for (i; i < groupList.length; i++) {
          newIds.push(groupList[i].id);
        }
        this.setState({
          selectedGroupIds: newIds,
        });
      }
    });
  }

  handleOwnerCallback(newObj) {
    this.setState({
      owners: newObj[0],
    });
  }

  handleRemoveProject() {
    this.setState({
      isOpenMDP: true,
    });
  }

  handleMDPClose() {
    this.setState({
      isOpenMDP: false,
    });
  }

  handleMAGClose() {
    this.setState({
      isOpenMAG: false,
    });
  }

  handleMACClose() {
    this.setState({
      isOpenMAC: false,
      excludePolicyIds: [],
    });
  }

  handleVMOpen(e, name, index) {
    this.setState({
      isOpenVM: true,
      selectedVersionName: name,
      versionIndex: index,
    });
  }

  handleVMClose() {
    this.setState({
      isOpenVM: false,
      versionIndex: '',
      selectedVersionName: '',
    });
  }

  handleRemovePolicy() {
    const { policyValues, selectedPolicyList } = this.state;
    if (policyValues.length === 0) {
      return false;
    }
    const newState = selectedPolicyList.filter((item) => {
      return policyValues.indexOf(item.id) === -1;
    });
    this.setState({
      selectedPolicyList: newState,
      policyValues: [],
      isPolicyChecked: false,
    });
  }

  handleDeleteCallback() {
    const { handleDeleteCallback } = this.props;
    handleDeleteCallback();
  }

  handleAddUser() {
    this.setState({
      isOpenMAU: true,
    });
  }

  handleRemoveUser() {
    const { checkValue, selectedMemberList } = this.state;
    const newIds = [];
    let i = 0;

    if (checkValue.length === 0) {
      return false;
    }
    const newState = selectedMemberList.filter((item) => {
      return checkValue.indexOf(`${item.type}_${item.id}`) === -1;
    });
    this.setState({
      selectedMemberList: newState,
      checkValue: [],
      itemsChecked: false,
    }, () => {
      const groupList = selectedMemberList.filter((item) => {
        return item.type === 'group';
      });
      if (groupList.length !== 0) {
        for (i; i < groupList.length; i++) {
          newIds.push(groupList[i].id);
        }

        this.setState({
          selectedGroupIds: newIds,
        });
      } else {
        this.setState({
          selectedGroupIds: newIds,
        });
      }
    });
  }

  handleAddUserDefined() {
    this.setState({
      isOpenMUD: true,
    });
  }

  handleRemoveUserDefined() {
    const { selectedUserDefinedList, userDefinedValues } = this.state;
    const newData = selectedUserDefinedList.filter((item) => {
      return !userDefinedValues.includes(item.user_defined_id);
    });
    this.setState({
      selectedUserDefinedList: newData,
      isUserdefinedCheckedAll: false,
    });
  }

  handleAddUserDefinedCallback(rowData) {
    const { selectedUserDefinedList } = this.state;
    this.setState({
      selectedUserDefinedList: [...selectedUserDefinedList, ...rowData],
    });
  }

  handleMAUClose() {
    this.setState({
      isOpenMAU: false,
    });
  }

  handleMUDClose() {
    this.setState({
      isOpenMUD: false,
    });
  }

  handleCopy(value) {
    navigator.clipboard.writeText(value).then(() => {
      this.setState({ copied: true }, () => {
        setTimeout(() => { return this.setState({ copied: false }); }, 2000);
      });
    }).catch((err) => { return console.error('Copy failed', err); });
  }

  handleChangeOwner() {
    this.setState({
      isOpenMCO: true,
    });
  }

  handleMCOClose() {
    this.setState({
      isOpenMCO: false,
    });
  }

  handleOpenFileInfoPopup(projectId, idx) {
    const status = {
      filesInfo: `${idx}_${projectId}`
    };
    api
      .getsUploadedFileData(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          uploadedFileList: data.uploaded_list,
          popupStatus: status,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleCloseFileInfoPopup() {
    const status = {
      filesInfo: '',
    };
    this.setState({
      popupStatus: status,
      uploadedFileList: [],
    });
  }

  handleChangeLicnese = (e) => {
    const { translate } = this.props;
    const string = e.target.value;
    const trimmedString = string.replace(/\s/g, '');

    if (trimmedString === '' && string !== '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.search_string_with_space');
      this.setState({
        isOpenAttentionModal: true,
      });
      return;
    }

    this.setState({
      declaredLicense: string,
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (string === '') {
      this.setState({
        revertDeclaredLicense: '',
        selectedResultData: '',
      });
    }

    this.typingTimeout = setTimeout(() => {
      this.searchDeclaredLicense(string);
    }, 1000);
  };

  handleFocusOnLicense = () => {
    const { declaredLicense, revertDeclaredLicense } = this.state;
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    const searchKeyword = '';

    this.setState({
      selectedResultData: '',
    });

    if (declaredLicense === revertDeclaredLicense) {
      this.typingTimeout = setTimeout(() => {
        this.searchDeclaredLicense(declaredLicense);
      }, 300);
    } else {
      this.typingTimeout = setTimeout(() => {
        this.searchDeclaredLicense(searchKeyword);
      }, 300);
    }
  };

  handleBlurOnLicense = () => {
    const { selectedResultData, revertDeclaredLicense } = this.state;

    if (selectedResultData === '') {
      this.setState({
        declaredLicense: revertDeclaredLicense,
      });
    }
    this.setState({
      isActiveResult: false,
    });
  };

  handleLicenseResultSelect = (e, result) => {
    this.setState({
      isActiveResult: false,
      declaredLicense: result.name,
      revertDeclaredLicense: result.name,
      selectedResultData: result.name,
    });
  };

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  getProjectDetail(projectId) {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getProjectDetail(projectId)
        .then((response) => {
          const data = response.response;
          const {
            description,
            id,
            info,
            name,
            owners,
            versions,
            members,
            groups,
            status,
            company_policy,
            project_policy,
            company_user_defined,
            project_user_defined,
            declared_license
          } = data;

          const typedMembers = members.map((member) => { return { ...member, type: 'user' }; });
          const typedGroups = groups.map((group) => { return { ...group, type: 'group' }; });
          const versionsWithStatus = versions.map((version) => { return { ...version, status: 'keep' }; });

          const groupIds = groups.map((item) => {
            return item.id;
          });

          this.setState({
            description,
            id,
            info,
            projectName: name,
            owners,
            status,
            versionList: [...versionsWithStatus],
            selectedPolicyList: [...company_policy, ...project_policy],
            selectedMemberList: [...typedMembers, ...typedGroups],
            selectedGroupIds: groupIds,
            selectedUserDefinedList: [...company_user_defined, ...project_user_defined],
            isLoading: false,
            declaredLicense: declared_license,
            revertDeclaredLicense: declared_license,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  deleteNewVersion = () => {
    const { versionList, versionIndex } = this.state;
    const versions = versionList;
    const item = versions[versionIndex];
    item.status = 'delete';

    this.setState({
      versionList: versions,
      isOpenVM: false,
    });
  };

  addNewVersion() {
    const { projectVersion, versionList } = this.state;
    const { translate } = this.props;
    let isUnique = false;

    if (projectVersion.trim().length === 0) {
      this.setState({
        projectVersionError: translate('modal.error.project_version_required'),
      });
      this.projectVersionNM.current.scrollIntoView();
      return false;
    }
    if (versionList.length !== 0) {
      const checkUnique = versionList.filter((item) => {
        return projectVersion === item.name && item.status !== 'delete';
      });
      if (checkUnique.length !== 0) {
        isUnique = true;
      }
    }

    if (isUnique) {
      this.setState({
        projectVersionError: translate('modal.error.duplicate_project_version'),
      });
      this.projectVersionNM.current.scrollIntoView();
    } else {
      const newObj = {
        id: 0,
        created: '-',
        last_uploaded: '-',
        name: projectVersion,
        scanned_size: '0 Bytes',
        uploaded_count: 0,
        status: 'add',
      };

      this.setState({
        projectVersion: '',
        versionList: [newObj, ...versionList],
      });
    }
  }

  searchDeclaredLicense(searchKeyword) {
    api
      .searchDeclaredLicense({
        search: searchKeyword,
        limit: 25,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
          };
        });

        if (searchKeyword !== '' && data.indexOf(searchKeyword) === -1) {
          const newComponent = {
            id: 'exact',
            name: searchKeyword,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          isActiveResult: true,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  validateFields() {
    const { projectName, versionList, selectedPolicyList } = this.state;
    const { translate } = this.props;

    const validation = {
      projectName: true,
      projectVersion: true,
      selectedPolicy: true,
    };

    if (projectName.trim().length === 0) {
      this.setState({
        projectNameError: translate('modal.error.project_required'),
      });
      if (this.projectNM?.current) {
        this.projectNM.current.scrollIntoView();
      }
      if (this.nameInput?.current) {
        this.nameInput.current.focus();
      }
      validation.projectName = false;
      return false;
    }

    if (this.getByteLength(projectName) > 30) {
      this.setState({
        projectNameError: translate('modal.error.project_limited_char'),
      });
      if (this.projectNM?.current) {
        this.projectNM.current.scrollIntoView();
      }
      if (this.nameInput?.current) {
        this.nameInput.current.focus();
      }
      validation.projectName = false;
      return false;
    }

    if (versionList.length === 0) {
      this.setState({
        projectVersionError: translate('modal.error.project_version_required'),
      });
      if (this.projectVersionNM?.current) {
        this.projectVersionNM.current.scrollIntoView();
      }
      if (this.versionInput?.current) {
        this.versionInput.current.focus();
      }
      validation.projectVersion = false;
      return false;
    }
    if (selectedPolicyList.length !== 0) {
      const component = [];
      const security = [];
      const license = [];
      const litigator = [];

      selectedPolicyList.forEach((item) => {
        if (item.category === 'component') component.push(item);
        if (item.category === 'security') security.push(item);
        if (item.category === 'license') license.push(item);
        if (item.category === 'litigator') litigator.push(item);
      });

      if (component.length > 1 || security.length > 1 || license.length > 1 || litigator.length > 1) {
        this.setState({
          appliedPolicerError: translate('modal.error.applied_policy_error'),
        });
        if (this.appliedPL?.current) {
          this.appliedPL.current.scrollIntoView();
        }
        validation.selectedPolicy = false;
        return false;
      }
    }

    return validation.projectName && validation.projectVersion && validation.selectedPolicy;
  }

  closeEditProjectModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  closeReportModal() {
    this.setState({
      isOpenReportModal: false,
    });
  }

  closeAttentionModal() {
    this.setState({
      isOpenAttentionModal: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  openTooltipWithKeyName(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithKeyName: id });
    }, 250);
  }

  closeTooltipWithKeyName() {
    this.setState({ tooltipWithKeyName: '' });
    clearTimeout(this.timeout);
  }

  openTooltipWithDetailValue(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithDetailValue: id });
    }, 250);
  }

  closeTooltipWithDetailValue() {
    this.setState({ tooltipWithDetailValue: '' });
    clearTimeout(this.timeout);
  }

  exportProjectToPDF() {
    const { translate } = this.props;
    const { id, projectName } = this.state;

    this.setState({
      isDownloadingReport: true,
      isOpenReportModal: true,
    });
    api
      .getProjectExportSettings(id)
      .then((res) => {
        const currentDate = new Date().toISOString().slice(0, 10);

        const fileName = `${projectName}_${currentDate}.pdf`;

        const blob = new Blob([res], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, fileName);

        this.modalAction = translate('modal.title.notice');
        this.modalBody = translate('modal.message.export_send_local');

        this.setState({
          isDownloadingReport: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          isDownloadingReport: false,
        });
      });
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    );
  }

  renderTypeValue(rowData) {
    const { translate } = this.props;
    if (rowData.type === 'component') {
      if (rowData.key2 === null || rowData.key2 === '') {
        return translate('list.title.component');
      }
      return translate('list.title.component_version');
    }
    if (rowData.type === 'hash') {
      return translate('settings.list.type_hash');
    }
  }

  renderKeyName(rowData) {
    const { translate } = this.props;
    const { tooltipWithKeyName, copied } = this.state;
    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {rowData.key1}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithKeyName === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithKeyName(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithKeyName}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '470px' }}>
              <label>
                {translate('settings.list.sha256')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key1); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={rowData.key1} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key1}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithKeyName === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithKeyName(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithKeyName}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key1); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key1} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  renderKeyNameDetail(rowData) {
    const { translate } = this.props;
    const { tooltipWithDetailValue, copied } = this.state;
    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {this.formatBytes(rowData.key2)}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithDetailValue === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithDetailValue(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithDetailValue}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '150px' }}>
              <label>
                {translate('settings.list.size')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key2); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={this.formatBytes(rowData.key2)} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key2}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithDetailValue === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithDetailValue(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithDetailValue}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component_version')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key2); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key2} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  render() {
    const {
      description,
      info,
      selectedMemberList,
      projectName,
      owners,
      versionList,
      projectVersion,
      viewPoint,
      checkValue,
      itemsChecked,
      selectedPolicyList,
      isPolicyChecked,
      policyValues,
      status,
      isLoading,
      popupStatus,
      projectNameError,
      projectVersionError,
      appliedPolicerError,
      appliedUserDefinedError,
      isOpenMEP,
      isOpenMAU,
      isOpenMAC,
      isOpenMAG,
      isOpenMCO,
      isOpenMDP,
      isOpenMUD,
      isOpenVM,
      isLoader,
      id,
      selectedGroupIds,
      selectedUserDefinedList,
      userDefinedValues,
      isUserdefinedCheckedAll,
      modalAlert,
      modalAlertTitle,
      modalAlertMsg,
      uploadedFileList,
      selectedVersionName,
      isDownloadingReport,
      isOpenReportModal,
      declaredLicense,
      resultList,
      isActiveResult,
      isOpenAttentionModal,
      excludePolicyIds,
    } = this.state;

    const { translate, location, state } = this.props;

    const statusValue = [
      { key: 1, text: translate('modal.title.active'), value: 'active' },
      { key: 2, text: translate('modal.title.inactive'), value: 'inactive' },
    ];
    const projectNameErrorClass = projectNameError !== '' ? 'show' : '';
    const projectVersionErrorClass = projectVersionError !== '' ? 'show' : '';
    const appliedPolicerErrorClass = appliedPolicerError !== '' ? 'show' : '';
    const appliedUserdefinedErrorClass = appliedUserDefinedError !== '' ? 'show' : '';

    const getModalContent = () => {
      if (isLoading) {
        return <Loader />;
      }
      return (
        <div className="setting_popup_contnets">
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={this.projectNM}
            >
              {translate('settings.list.project_name')}
              <em style={{ marginLeft: '0' }} className="asterisk" />
            </h3>
            <div className="setting_popup_content">
              <input
                type="text"
                value={projectName}
                placeholder={translate('settings.list.project_name')}
                onChange={this.handleProjectNameChange}
                ref={this.nameInput}
              />
              <div
                className={`error ${projectNameErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {projectNameError}
              </div>
            </div>
          </div>

          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('list.title.description')}</h3>
            <div className="setting_popup_content">
              <textarea
                value={description || ''}
                placeholder={translate('list.title.description')}
                onChange={this.handleDescChange}
                rows="3"
              />
            </div>
          </div>

          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
            >
              {translate('settings.list.declared_license')}
            </h3>
            <div className="setting_popup_content" style={{ position: 'relative' }}>
              <input
                className=""
                style={{ width: '25.5%' }}
                type="text"
                value={declaredLicense}
                placeholder={translate('settings.list.declared_license')}
                onChange={this.handleChangeLicnese}
                onFocus={this.handleFocusOnLicense}
                onBlur={this.handleBlurOnLicense}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleLicenseResultSelect}
                isShowResult={isActiveResult}
                translate={translate}
              />
            </div>
          </div>

          <div
            className="setting_popup_content_wrap"
            ref={this.projectVersionNM}
          >
            <h3 className="content_title">
              {translate('list.title.project_version')}
              <em style={{ marginLeft: '0' }} className="asterisk" />
            </h3>
            <div className="setting_popup_content">
              <table className="table">
                <colgroup>
                  <col />
                  <col style={{ width: '72px' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td className="with_button">
                      <input
                        type="text"
                        value={projectVersion}
                        placeholder={translate('modal.new_scan.title.new_version')}
                        onKeyPress={this.handleAddNewVersion}
                        onChange={this.handleProjectVersionChange}
                        ref={this.versionInput}
                      />
                      <div
                        className={`error ${projectVersionErrorClass}`}
                        style={{
                          marginTop: '6px',
                          marginLeft: '5px',
                          fontSize: '12px',
                          fontWeight: '700',
                          color: '#ef4136',
                          postion: 'absolute',
                          minHeight: '18px',
                        }}
                      >
                        {projectVersionError}
                      </div>
                    </td>
                    <td className="with_button">
                      <a
                        className="blue_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.addNewVersion}
                        onKeyUp={this.addNewVersion}
                      >
                        {translate('modal.button.add')}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="setting_popup_content">
              <div className="table_wrap table_type_3">
                <table
                  className="table table_type_3"
                  style={{
                    padding: '0 10px',
                    border: '1px solid #e5e5e5',
                    borderRadius: '5px',
                  }}
                >
                  <colgroup>
                    <col style={{ width: '' }} />
                    <col style={{ width: '140px' }} />
                    <col style={{ width: '140px' }} />
                    <col style={{ width: '180px' }} />
                    <col style={{ width: '180px' }} />
                    <col style={{ width: '81px' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>{translate('modal.place_holder.version_name')}</th>
                      <th>{translate('modal.new_scan.place_holder.uploaded_files')}</th>
                      <th>{translate('list.title.scanned_size')}</th>
                      <th>{translate('modal.title.created')}</th>
                      <th>{translate('modal.title.last_updated')}</th>
                      <th>&nbsp;</th>
                    </tr>
                    {versionList.length !== 0
                      ? versionList.map((list, index) => {
                        return (
                          <tr
                            key={list.id}
                            className={cx({
                              hide: list.status === 'delete',
                            })}
                          >
                            <td className="strong">
                              <input
                                type="text"
                                value={list.name}
                                placeholder={translate('modal.place_holder.version_name')}
                                onChange={(event) => {
                                  this.handleVersionChange(
                                    event,
                                    index
                                  );
                                }}
                              />
                            </td>
                            <td className="strong">
                              {list.uploaded_count === 0 ? (
                                <div className="number">
                                  {list.uploaded_count}
                                </div>
                              ) : (
                                <Popup
                                  trigger={(
                                    <div
                                      className="number"
                                      style={{ cursor: 'pointer', marginLeft: '2%' }}
                                    >
                                      {list.uploaded_count}
                                    </div>
                                  )}
                                  on="click"
                                  position="bottom left"
                                  open={
                                    popupStatus.filesInfo === `${index}_${list.id}`
                                  }
                                  onOpen={() => {
                                    return this.handleOpenFileInfoPopup(list.id, index);
                                  }}
                                  onClose={this.handleCloseFileInfoPopup}
                                >
                                  <List>
                                    {uploadedFileList
                                      ? uploadedFileList.map(
                                        (item) => {
                                          return (
                                            <List.Item key={uuidv4()}>
                                              <List.Icon name="file" />
                                              <List.Content>{item}</List.Content>
                                            </List.Item>
                                          );
                                        }
                                      )
                                      : null}
                                  </List>
                                </Popup>
                              )}
                            </td>
                            <td className="strong">
                              <div className="number">
                                {list.scanned_size}
                              </div>
                            </td>
                            <td className="strong">{list.created}</td>
                            <td className="strong">
                              {list.last_uploaded || '-'}
                            </td>
                            <td className="strong">
                              <a
                                className="red_button"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => { return this.handleVMOpen(e, list.name, index); }}
                                onKeyUp={(e) => { return this.handleVMOpen(e, list.name, index); }}
                              >
                                {translate('modal.button.delete')}
                              </a>
                            </td>
                          </tr>
                        );
                      })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('contents_header.place_holder.project_owner')}</h3>
            <div className="setting_popup_content">
              <div className="table_wrap table_type_3">
                <table className="table table_type_3">
                  <colgroup>
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '40%' }} />
                    <col style={{ width: '40%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>{translate('modal.title.user_name')}</th>
                      <th>{translate('modal.title.email')}</th>
                      <th className="tac">&nbsp;</th>
                    </tr>
                    <tr>
                      <td className="strong">
                        <img
                          src={this.getProfileImg(owners.id)}
                          alt=""
                          style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                        />
                        &nbsp;
                        {owners.profile}
                      </td>
                      <td className="strong">
                        {this.convertToString(owners.email)}
                      </td>
                      <td className="strong tar">
                        <div
                          className="deep_gray_button"
                          style={{ cursor: 'pointer' }}
                          onClick={this.handleChangeOwner}
                          onKeyUp={this.handleChangeOwner}
                        >
                          {translate('modal.button.change_owner')}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="setting_popup_content_wrap">
            <table className="table">
              <colgroup>
                <col style={{ width: '10%' }} />
                <col style={{ width: '26%' }} />
                <col style={{ width: '32%' }} />
                <col style={{ width: '32%' }} />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <h3 className="content_title">{translate('settings.list.status')}</h3>
                    <div className="setting_popup_content">
                      <Dropdown
                        className="status"
                        onChange={this.handleStatusChange}
                        value={status}
                        options={statusValue}
                        fluid
                        selection
                      />
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('settings.list.created_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{info.created}</div>
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('modal.cve.last_modified_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{info.last_modified}</div>
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('contents_header.menu.last_uploaded_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{info.last_uploaded}</div>
                    </div>
                  </td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={this.appliedPL}
            >
              {translate('settings.list.applied_policy')}
              (
              {selectedPolicyList.length}
              )
              <div className="button_box">
                <a
                  className="delete_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleRemovePolicy}
                  onKeyUp={this.handleRemovePolicy}
                >
                  {translate('modal.button.delete')}
                </a>
                <a
                  className="add_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleAddPolicy}
                  onKeyUp={this.handleAddPolicy}
                >
                  {translate('modal.button.add_policy')}
                </a>
              </div>
            </h3>
            {
              !appliedPolicerError && (
                <div className="text_box_type_2">
                  {translate('modal.message.policy_permission')}
                </div>
              )
            }
            <div
              className={`error ${appliedPolicerErrorClass}`}
              style={{
                marginTop: '6px',
                marginLeft: '5px',
                fontSize: '12px',
                fontWeight: '700',
                color: '#ef4136',
              }}
            >
              {appliedPolicerError}
            </div>
            <div className="setting_popup_content">
              <div className="table_wrap table_type_3" style={{ padding: '0 10px', border: '1px solid #e5e5e5', borderRadius: '5px' }}>
                <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                  <colgroup>
                    <col style={{ width: '3.7%' }} />
                    <col style={{ width: '35%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <Checkbox
                          checked={isPolicyChecked}
                          onChange={this.handlePolicyCheckAll}
                          disabled={selectedPolicyList.length === 0}
                        />
                      </th>
                      <th>{translate('modal.title.policy_name')}</th>
                      <th>{translate('settings.list.category')}</th>
                      <th>{translate('settings.list.condition')}</th>
                      <th className="tac">{translate('settings.list.applied')}</th>
                    </tr>
                    {
                      selectedPolicyList.length !== 0 ? (
                        selectedPolicyList.map((item) => {
                          return (
                            <tr key={uuidv4()}>
                              <td className="strong">
                                <Checkbox
                                  value={item.id}
                                  checked={policyValues.indexOf(item.id) > -1}
                                  onChange={this.handlePolicyCheckChange}
                                  disabled={item.applied === 'company'}
                                />
                              </td>
                              <td className="strong">{item.name}</td>
                              <td className="strong">{item.category}</td>
                              <td className="strong">{item.condition}</td>
                              <td className="strong tac">
                                {
                                  item.applied === 'company' ? translate('settings.list.company_policy') : item.applied
                                }
                              </td>
                            </tr>
                          );
                        })
                      ) : null
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={this.appliedUD}
            >
              {translate('contents_header.menu.user_defined')}
              (
              {selectedUserDefinedList.length}
              )
              <div className="button_box">
                <a
                  className="delete_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleRemoveUserDefined}
                  onKeyUp={this.handleRemoveUserDefined}
                >
                  {translate('modal.button.delete')}
                </a>
                <a
                  className="add_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleAddUserDefined}
                  onKeyUp={this.handleAddUserDefined}
                >
                  {translate('modal.button.add_user_defined')}
                </a>
              </div>
            </h3>
            <div
              className={`error ${appliedUserdefinedErrorClass}`}
              style={{
                marginTop: '6px',
                marginLeft: '5px',
                fontSize: '12px',
                fontWeight: '700',
                color: '#ef4136',
              }}
            >
              {appliedUserDefinedError}
            </div>
            <div className="setting_popup_content">
              <div className="table_wrap table_type_3" style={{ padding: '0 10px', border: '1px solid #e5e5e5', borderRadius: '5px' }}>
                <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                  <colgroup>
                    <col style={{ width: '3.7%' }} />
                    <col style={{ width: '23%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '18%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <Checkbox
                          checked={isUserdefinedCheckedAll}
                          onChange={this.handleUserDefinedCheckAllChange}
                          disabled={selectedUserDefinedList.length === 0}
                        />
                      </th>
                      <th>{translate('settings.list.defined_target')}</th>
                      <th>{translate('settings.list.type')}</th>
                      <th>{translate('settings.list.key_name')}</th>
                      <th>{translate('settings.list.value_detail')}</th>
                      <th className="tac">{translate('settings.list.applied')}</th>
                    </tr>
                    {
                      selectedUserDefinedList.length !== 0 ? (
                        selectedUserDefinedList.map((item) => {
                          return (
                            <tr key={item.user_defined_id}>
                              <td className="strong">
                                <Checkbox
                                  value={item.user_defined_id}
                                  checked={userDefinedValues.indexOf(item.user_defined_id) > -1}
                                  disabled={item.applied === 'company'}
                                  onChange={this.handleUserDefinedCheckChange}
                                />
                              </td>
                              <td className="strong">
                                {item.target}
                              </td>
                              <td className="strong">
                                {this.renderTypeValue(item)}
                              </td>
                              <td className="strong">
                                {this.renderKeyName(item)}
                              </td>
                              <td className="strong">
                                {this.renderKeyNameDetail(item)}
                              </td>
                              <td className="strong tac">
                                {
                                  item.applied === 'company' ? translate('settings.list.company_policy') : item.applied
                                }
                              </td>
                            </tr>
                          );
                        })
                      ) : null
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={this.projectMB}
            >
              {translate('modal.title.project_member')}
              (
              {selectedMemberList.length}
              )
              <div className="button_box">
                <a
                  className="delete_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleRemoveUser}
                  onKeyUp={this.handleRemoveUser}
                >
                  {translate('modal.button.delete')}
                </a>
                <a
                  className="add_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleAddUser}
                  onKeyUp={this.handleAddUser}
                >
                  {translate('modal.button.add_user')}
                </a>
                <a
                  className="add_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleAddGroup}
                  onKeyUp={this.handleAddGroup}
                >
                  {translate('modal.button.add_group')}
                </a>
              </div>
            </h3>
            <div className="setting_popup_content">
              <div className="table_wrap table_type_3">
                <table
                  className="table table_type_3"
                  style={{
                    padding: '0 10px',
                    border: '1px solid #e5e5e5',
                    borderRadius: '5px',
                  }}
                >
                  <colgroup>
                    <col style={{ width: '3.7%' }} />
                    <col style={{ width: '8%' }} />
                    <col style={{ width: '55%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '13%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <Checkbox
                          checked={itemsChecked}
                          onChange={this.handleMemberCheckAll}
                          disabled={selectedMemberList.length === 0}
                        />
                      </th>
                      <th>{translate('settings.list.type')}</th>
                      <th>{translate('system.list.name')}</th>
                      <th>{translate('settings.list.email')}</th>
                      <th className="tac">{translate('modal.title.assigned')}</th>
                    </tr>
                    {selectedMemberList.length !== 0
                      ? selectedMemberList.map((list) => {
                        if (list.type === 'group') {
                          return (
                            <tr key={uuidv4()}>
                              <td className="strong">
                                <Checkbox
                                  value={`${list.type}_${list.id}`}
                                  checked={checkValue.indexOf(`${list.type}_${list.id}`) > -1}
                                  onChange={this.handleMemberCheckChange}
                                  disabled={list.email === state.user.email}
                                />
                              </td>
                              <td className="string">{translate('settings.list.group')}</td>
                              <td className="strong">
                                <img
                                  src={this.getProfileImg(list.id)}
                                  alt=""
                                  style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                />
                                &nbsp;
                                {' '}
                                {list.name}
                              </td>
                              <td className="strong">-</td>
                              <td className="strong" style={{ textAlign: 'center' }}>{list.assigned || '-'}</td>
                            </tr>
                          );
                        }
                        return (
                          <tr key={uuidv4()}>
                            <td className="strong">
                              <Checkbox
                                value={`${list.type}_${list.id}`}
                                checked={
                                  checkValue.indexOf(`${list.type}_${list.id}`) > -1
                                }
                                onChange={this.handleMemberCheckChange}
                                disabled={list.email === owners.email}
                              />
                            </td>
                            <td className="string">{translate('settings.list.user')}</td>
                            {list.email === owners.email ? (
                              <td className="strong">
                                <img
                                  src={this.getProfileImg(list.id)}
                                  alt=""
                                  style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                />
                                &nbsp;
                                {list.profile}
                                (
                                {translate('contents_header.place_holder.project_owner')}
                                )
                              </td>
                            ) : (
                              <td className="strong">
                                <img
                                  src={this.getProfileImg(list.id)}
                                  alt=""
                                  style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                />
                                  &nbsp;
                                {' '}
                                {list.profile}
                              </td>
                            )}
                            <td className="strong">
                              {this.convertToString(list.email)}
                            </td>
                            <td
                              className="strong"
                              style={{ textAlign: 'center' }}
                            >
                              {list.assigned || '-'}
                            </td>
                          </tr>
                        );
                      })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="setting_popup_bottom">
            <a
              className="red"
              style={{ cursor: 'pointer', lineHeight: '15px' }}
              onClick={this.handleRemoveProject}
              onKeyUp={this.handleRemoveProject}
            >
              {translate('modal.button.delet_this_project')}
            </a>
          </div>
        </div>
      );
    };

    return (
      <Modal
        open={isOpenMEP}
        onClose={this.closeEditProjectModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup has_popup_inner_menu">
            <div className="setting_popup_header">
              <h2 className="popup_name">{translate('modal.title.project_detail')}</h2>
              <a
                className="popup_close_button"
                onClick={this.closeEditProjectModal}
                onKeyUp={this.closeEditProjectModal}
              >
                <img src={closeBtn} alt="" />
              </a>
              <div className="popup_inner_wrap">
                <div className="popup_inner_menu">
                  <a
                    className={cx({
                      active: viewPoint === '1',
                    })}
                    data-id="1"
                    onClick={this.handleViewPostion}
                    onKeyUp={this.handleViewPostion}
                  >
                    {translate('modal.title.project_information')}
                  </a>
                  <a
                    className={cx({
                      active: viewPoint === '3',
                    })}
                    data-id="3"
                    onClick={this.handleViewPostion}
                    onKeyUp={this.handleViewPostion}
                  >
                    {translate('settings.list.applied_policy')}
                    (
                    {selectedPolicyList.length}
                    )
                  </a>
                  <a
                    className={cx({
                      active: viewPoint === '2',
                    })}
                    data-id="2"
                    onClick={this.handleViewPostion}
                    onKeyUp={this.handleViewPostion}
                  >
                    {translate('modal.title.project_member')}
                    (
                    {selectedMemberList.length}
                    )
                  </a>
                  <a
                    className={cx({
                      active: viewPoint === '4',
                    })}
                    data-id="4"
                    onClick={this.handleViewPostion}
                    onKeyUp={this.handleViewPostion}
                  >
                    {translate('contents_header.menu.user_defined')}
                    (
                    {selectedUserDefinedList.length}
                    )
                  </a>
                </div>
                <div className="popup_inner_button_wrap">
                  <Popup
                    trigger={(
                      <a
                        className="export_button"
                        onClick={this.exportProjectToPDF}
                        onKeyUp={this.exportProjectToPDF}
                      >
                        <Icon name="file pdf outline" />
                        {translate('modal.button.export_pdf')}
                      </a>
                    )}
                    position="bottom right"
                  >
                    <div style={{ fontSize: '12px', color: '#4a4a4a', lineHeight: '1.5' }}>
                      {translate('modal.message.export_project_pdf')}
                    </div>
                  </Popup>
                </div>
              </div>
            </div>
            <Scrollbars
              style={{
                position: 'relative',
                overflow: 'hidden',
                height: '100%',
              }}
              onScroll={this.handleOnScroll}
            >
              {getModalContent()}
            </Scrollbars>
            {
              isLoading ? null : (
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeEditProjectModal}
                    onKeyUp={this.closeEditProjectModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.handleSave}
                    onKeyUp={this.handleSave}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              )
            }
          </div>
        </div>
        <AssigningUserModal
          isOpenMAU={isOpenMAU}
          closeModal={this.handleMAUClose}
          completeCallback={this.handleMemberList}
          projectName={projectName}
          location={location}
          members={selectedMemberList}
          translate={translate}
        />
        <ChangeOwnerModal
          isOpenMCO={isOpenMCO}
          closeModal={this.handleMCOClose}
          completeCallback={this.handleOwnerCallback}
          projectName={projectName}
          members={selectedMemberList}
          owners={owners}
          translate={translate}
        />
        <DeleteProjectModal
          isOpenMDP={isOpenMDP}
          closeModal={this.handleMDPClose}
          completeCallback={this.handleDeleteCallback}
          location={location}
          data={id}
          status={isOpenMEP}
          translate={translate}
        />
        <ApplyingPolicyModal
          isOpenMAC={isOpenMAC}
          closeModal={this.handleMACClose}
          excludeIds={excludePolicyIds}
          completeCallback={this.handlePolicyList}
          translate={translate}
        />
        <AssigningGroupModal
          isOpenMAG={isOpenMAG}
          closeModal={this.handleMAGClose}
          excludeIds={selectedGroupIds}
          completeCallback={this.handleMemberList}
          translate={translate}
        />
        <AddUserDefinedModal
          isOpenMUD={isOpenMUD}
          selectedUserDefinedList={selectedUserDefinedList}
          closeModal={this.handleMUDClose}
          handleAddCallback={this.handleAddUserDefinedCallback}
          translate={translate}
        />
        <Modal open={modalAlert} onClose={this.handleCloseAlert}>
          {isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{modalAlertTitle}</h2>
                  <p className="text">{modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.handleCloseAlert}
                      onKeyUp={this.handleCloseAlert}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={isOpenVM} onClose={this.handleVMClose}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">
                  {translate('modal.message.delete_version')}
                  <br />
                  &quot;
                  {selectedVersionName}
                  &quot;
                </p>
                <p className="small_text">{translate('modal.message.warn_delete_version')}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.handleVMClose} onKeyUp={this.handleVMClose}>
                    {translate('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.deleteNewVersion} onKeyUp={this.deleteNewVersion}>
                    {translate('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenReportModal} onClose={this.closeReportModal}>
          {isDownloadingReport ? (
            <div className="modal_popup_wrap export_data_wrap">
              <div className="modal_popup_box export_data_box">
                <div className="modal_popup export_data">
                  <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                    <Loader
                      style={{
                        position: 'relative',
                        width: '80%',
                        height: '80%',
                        marginBottom: '15%',
                      }}
                    />
                    <span
                      style={{
                        fontWeight: '500',
                        fontSize: '16px',
                        marginTop: '35%',
                        display: 'inline-block',
                      }}
                    >
                      {translate('modal.message.prepare_report_download')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.closeReportModal}
                      onKeyUp={this.closeReportModal}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={isOpenAttentionModal} onClose={this.closeAttentionModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeAttentionModal}
                    onKeyUp={this.closeAttentionModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(EditProjectModal)));
